"use client";

import { useQuery } from "@tanstack/react-query";

export interface Facets {
  authors: string[];
  categories: string[];
  traits: string[];
  keywords: string[];
}

export function useFacets() {
  return useQuery<Facets>({
    queryKey: ["facets"],
    queryFn: async () => {
      const response = await fetch("/api/facets");
      if (!response.ok) throw new Error("Failed to load facets");
      return response.json();
    },
    staleTime: 5 * 60 * 1000,
  });
}
